import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button, FormControl, Input, useToast} from "@chakra-ui/react";
import {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useSaveRules} from "../../../api/moderation";

const Label = styled.div``;

const AddRuleSheet = styled(({className, community, communityRules, i, onClose}) => {

    const [rules, setRules] = useState(communityRules);
    const [rule, setRule] = useState(rules[i] || '');
    const {feedbackCh} = useFeedback();
    const toast = useToast();
    const saveRules = useSaveRules(feedbackCh);
    const [saving, setSaving] = useState(false);
    const handleSave = async (type) => {
        setSaving(true);
        const r = [... rules];
        let updated;
        if (i === -1) {
            // add new
            updated = [...r, rule];
        } else if (type === 'delete') {
            // delete
            updated = r.filter((_, index) => index != i);
        } else {
            // replace
            r[i] = rule;
            updated = r;
        }
        // save to API
        await saveRules(JSON.stringify(updated), community);
        setSaving(false);
        onClose();
    }

        return (
            <div className={className}>

                <Header>
                    <Title>{i !== -1 ? 'Edit Rule' : 'Add Rule'}</Title>
                </Header>

                <FormControl>
                    <Label>Rule</Label>
                    <Input placeholder="Cats" value={rule} onChange={(e) => setRule(e.currentTarget.value)}/>
                </FormControl>

                <Button variant={"blue"} style={{width: '100%', marginTop: '24px'}} onClick={handleSave}>Save</Button>

                {i !== -1 &&
                    <Button variant={"grey"} style={{width: '100%'}} mt={2} onClick={() => handleSave('delete')}>Delete</Button>
                }

            </div>
        );
    }
)`
  ${Label} {
    font-weight: 600;
    font-size: 15px;
    padding: 6px 0;
  }
`;

export default AddRuleSheet;
